import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IHttpResult } from '@leandredev/common_js';
import { IHttpOption, RunTimeDataService } from '@leandredev/common_ng_14';
import { ISigninResponse, ISigninRequest, IlostPasswordRequest, IresetPasswordRequest } from '@leandredev/dcbm-common-lib/dist/interfaces';
import * as dcbm from '@leandredev/dcbm-ng-lib';

import { Observable } from 'rxjs';
import { I_Tokken } from 'src/app/utils/interfaces';

import { environment } from 'src/environments/environment';
import { I_Data_Env } from 'src/environments/interface';

const AUTH_REFRESH_TOKKEN_URL = environment.data.authServiceUrl + 'refreshToken';

@Injectable()
export class AuthenticationService implements Partial<dcbm.service.Authentication> {
  private service: dcbm.service.Authentication;

  constructor(private http: HttpClient, private runTimeDataService: RunTimeDataService) {
    this.service = new dcbm.service.Authentication(this.http, false);
    this.service.urlCollection = `${environment.data.api}authentication/`;

    this.runTimeDataService.getObservableStore('publicConf').subscribe((data: I_Data_Env) => {
      if (data) this.service.urlCollection = `${data.api}authentication/`;
    });
  }

  signIn<T extends ISigninResponse, U extends ISigninRequest>(body: U, query: any, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.signIn(body, query, options);
  }

  lostPassword<T, U extends IlostPasswordRequest>(body: U, query: any, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.lostPassword(body, query, options);
  }

  resetPassword<T, U extends IresetPasswordRequest>(body: U, query: any, options?: IHttpOption): Observable<IHttpResult<T>> {
    return this.service.resetPassword(body, query, options);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  refreshToken(_query: any, tokken: string, _options?: IHttpOption): Observable<IHttpResult<I_Tokken>> {
    const headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      jwt: tokken as string
    });

    return this.http.get<IHttpResult<I_Tokken>>(AUTH_REFRESH_TOKKEN_URL, { headers });
  }
}
